import { useContext } from "react";
import { FormContextMA } from "../form-context";
import {
  formatPhone,
  formatPhoneDocumentation,
} from "../../../helpers/functions";
import {
  relationshipTypeOptions,
  relationshipTypeThirdStepOptions,
} from "../../patient/create/options";
import { DataField, Divider, H2, P, Section } from "./common-components";
import { GetDropDownValue } from "./data";
import { AllergicRhinitisDocTypes, MedicationReviewDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const AlternateCaregiverInformation = ({ patient, formType }) => {
  // const { patient, formType } = useContext(FormContextMA);
  const caregiver = patient.caregiver?.[0] || null;
  if (
    ([AllergicRhinitisDocTypes.PhysicianReferralForm].includes(formType) ) &&
    !caregiver?.contactInfo?.primaryPhone
  ) {
    return null;
  }

  return (
    <>
      {[AllergicRhinitisDocTypes.InitialAssessment].includes(formType) || [MedicationReviewDocTypes.PharmacistWorksheet].includes(formType)? (
        <>
          <Section formType={formType}>
            <H2>Alternate Caregiver</H2>
            {caregiver ? (
              <>
                <div className="grid grid-cols-2">
                  <DataField
                    label="Name"
                    value={(
                      (caregiver.firstName || "") +
                      (caregiver.middleName ? ` ${caregiver.middleName}` : "") +
                      (caregiver.lastName ? ` ${caregiver.lastName}` : "")
                    ).trim()}
                  />
                  <DataField
                    label="Relationship"
                    value={GetDropDownValue(
                      [
                        ...relationshipTypeOptions,
                        ...relationshipTypeThirdStepOptions,
                      ],
                      caregiver.relationship
                    )}
                  />
                </div>
                <Divider />
                <div className="grid grid-cols-2">
                  <DataField
                    label="Primary Phone Number"
                    value={
                      caregiver.contactInfo?.primaryPhone
                        ? formatPhoneDocumentation(
                            caregiver.contactInfo.primaryPhone
                          )
                        : ""
                    }
                  />
                  {[AllergicRhinitisDocTypes.InitialAssessment].includes(
                    formType
                  ) || [MedicationReviewDocTypes.PharmacistWorksheet].includes(formType) ? (
                    <DataField
                      label="Secondary Phone"
                      value={
                        caregiver.contactInfo?.secondaryPhone
                          ? `${formatPhoneDocumentation(
                              caregiver.contactInfo.secondaryPhone
                            )}`
                          : ""
                      }
                    />
                  ) : null}
                </div>
                <div className="grid grid-cols-1">
                  <DataField
                    label="Email Address"
                    value={caregiver.contactInfo?.email}
                  />
                </div>
              </>
            ) : (
              <P className="font-semibold">No Alternate Caregiver</P>
            )}
          </Section>
        </>
      ) : (
        <>
          <Section formType={formType}>
            <H2>Alternate Caregiver</H2>
            {caregiver ? (
              <>
                <div className="grid grid-cols-2 gap-1">
                  <DataField
                    label="Name"
                    value={(
                      (caregiver.firstName || "") +
                      (caregiver.middleName ? ` ${caregiver.middleName}` : "") +
                      (caregiver.lastName ? ` ${caregiver.lastName}` : "")
                    ).trim()}
                  />
                  <DataField
                    label="Relationship"
                    value={GetDropDownValue(
                      [
                        ...relationshipTypeOptions,
                        ...relationshipTypeThirdStepOptions,
                      ],
                      caregiver.relationship
                    )}
                  />
                  <DataField
                    label="Primary Phone Number"
                    value={
                      caregiver.contactInfo?.primaryPhone
                        ? formatPhoneDocumentation(
                            caregiver.contactInfo.primaryPhone
                          )
                        : ""
                    }
                  />
                  <DataField
                    label="Email Address"
                    value={caregiver.contactInfo?.email}
                  />
                </div>
              </>
            ) : (
              <P className="font-semibold">No Alternate Caregiver</P>
            )}
          </Section>
        </>
      )}
    </>
  );
};
